module.exports = __webpack_public_path__ + "img/jacket2.ae740e70.png";